import { type BadgeProps, Badge as ChakraBadge } from "@chakra-ui/react";

export const Badge = ({ variant = "subtle", ...props }: BadgeProps) => {
  return <ChakraBadge mx={1} variant={variant} {...props} />;
};
